<template>
  <action-dispatcher
    action="lessons/getFavorites"
    :parameters="params"
    @success="success"
    class="view-my-list"
  >
    <div class="container-fluid">
      <h5 class="page-title mb-0">Minha lista</h5>
      <div v-if="filteredFavorites.length" class="row align-items-start">
        <lesson-quiz-item
          v-for="(lesson, i) in filteredFavorites"
          :key="`lesson-${i}`"
          class="col-12 col-sm-6 col-lg-3"
          :item="lesson"
          @update-my-list="refresh"
        />
      </div>
      <template v-else>
        <div class="d-flex justify-content-center mt-5 pt-5">
          <empty-icon message="Ainda não há aulas em sua lista" />
        </div>
      </template>
    </div>
  </action-dispatcher>
</template>

<script>
import LessonQuizItem from "@/components/lesson/LessonQuizItem";
import EmptyIcon from "@/assets/vueIcons/EmptyIcon";
export default {
  components: {
    LessonQuizItem,
    EmptyIcon
  },
  data() {
    return {
      favorites: [],
      loading: false,
      endResults: false,
      page: 1
    };
  },
  computed: {
    filteredFavorites() {
      return this.favorites.map(f => f.lesson);
    },
    params() {
      const limit = 8;
      return {
        limit,
        offset: limit * (this.page - 1)
      };
    }
  },
  methods: {
    handleInfinityScroll() {
      if (
        window.scrollY + window.innerHeight >=
        document.body.scrollHeight - 50
      ) {
        if (!this.endResults) {
          this.refresh();
        }
      }
    },
    success({ results, next }) {
      this.favorites = [...results];
      if (next) {
        this.page += 1;
      } else {
        this.endResults = true;
      }
    },
    refresh() {
      if (this.loading) return;

      this.loading = true;
      this.$store
        .dispatch("lessons/getFavorites", this.params)
        .then(this.success)
        .finally(() => {
          this.loading = false;
        });
    }
  },
  mounted() {
    window.addEventListener("scroll", this.handleInfinityScroll, {
      passive: true
    });
  },
  beforeDestroy() {
    window.removeEventListener("scroll", this.handleInfinityScroll, {
      passive: true
    });
  }
};
</script>

<style lang="scss" scoped>
.view-my-list {
  padding-top: 72px;
}
</style>
